import React, { FC } from 'react'
import { Title } from '@shared/ui/Typography/Title'
import { Text } from '@shared/ui/Typography/Text'
import Button from '@shared/ui/Actions/Button/Button'
import Modal from '@shared/ui/Overlays/Modal/Modal'
import s from './ConfirmationDialog.module.sass'

interface ConfirmationDialogProps {
  isVisible: boolean
  title: string
  description?: string
  confirmationText: string
  rejectionText: string
  onConfirm: () => void
  onReject: () => void
}

const ConfirmationDialog: FC<ConfirmationDialogProps> = ({
  isVisible,
  title,
  description,
  confirmationText,
  rejectionText,
  onConfirm,
  onReject,
}) => {
  if (!isVisible) return null

  return (
    <Modal size='S' handleClose={onReject} buttonClose={false}>
      <div className={s.container}>
        <div className={s.header}>
          <Title tag='h2' sizes='h2' className={s.title}>
            {title}
          </Title>

          {description && (
            <Text sizes='M' className={s.description}>
              {description}
            </Text>
          )}
        </div>

        <div className={s.actions}>
          <Button sizes='XL' mode='white-border' onClick={onConfirm} className={s['confirm-button']}>
            {confirmationText}
          </Button>

          <Button sizes='XL' mode='black' onClick={onReject} className={s['reject-button']}>
            {rejectionText}
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default ConfirmationDialog
